import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class SectionPanel extends BaseComponent {

	static get properties() {
		return {
			// Not named "title": HTMLElement.title is the native browser tooltip attribute.
			headertext: {type: String, attribute: false},
			style: {type: String},
			closable: {type: Boolean},
			collapsible: {type: Boolean},
			collapeAtFirst: {type: Boolean},
			noRemoveOnClose: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		var sectionPanel = this;
		sectionPanel.headertext = '';
		sectionPanel.style = '';
		sectionPanel.closable = false;
		sectionPanel.collapsible = false;
		sectionPanel.collapeAtFirst = false;
		sectionPanel.noRemoveOnClose = false;
		
		setTimeout(function(){
			sectionPanel.clearNativeTitleAttribute();
			sectionPanel.init();
		});
	}

	/**
	 * Keep ElementUtil.create({ title: '...' }) and element.title = '...' working
	 * without applying the native HTML title tooltip to the whole panel.
	 */
	get title() {
		return this.headertext;
	}

	set title(value) {
		this.headertext = value == null ? '' : String(value);
		this.clearNativeTitleAttribute();
	}

	setAttribute(name, value) {
		if (name === 'title') {
			this.headertext = value == null ? '' : String(value);
			return;
		}
		super.setAttribute(name, value);
	}

	clearNativeTitleAttribute() {
		if (this.hasAttribute('title')) {
			HTMLElement.prototype.removeAttribute.call(this, 'title');
		}
	}

	connectedCallback() {
		super.connectedCallback();
		if (this.hasAttribute('title')) {
			this.headertext = this.getAttribute('title') || '';
			this.clearNativeTitleAttribute();
		}
	}
	
	render() {	
		return html`
			<style>
				.section-panel {
					border-top: 1px solid lightgrey;
					border-left: 1px solid lightgrey;
					border-right: 1px solid lightgrey;
					border-bottom: 1px solid lightgrey;
				}
				.hide {
					display: none;
				}
			</style>
			<div class="section-panel" style="${this.style}">			
				<slot name="header"></slot>
				<div itemid="content" style='padding: 5px'>
					<slot name="content"></slot>
				</div>				
			</div>
		`;
	}
	
	init() {
		var sectionPanel = this;
		
		if (sectionPanel.headertext) {
			
			var headerDef = {
				tag: 'dl-section-title',
				slot: 'header',
				title: sectionPanel.headertext,
				listeners: {
					close: function(event) {		
						if (!sectionPanel.noRemoveOnClose) {
							sectionPanel.remove();						
						} else {
							//This does the inverse which is expand
							header.collapse();							
						}						
						var closeEvent = new CustomEvent('close', { detail: '' });
						sectionPanel.dispatchEvent(closeEvent);
						event.stopPropagation();
					},
					collapse: function() {
						ElementUtil.query(sectionPanel, 'content').classList.add('hide'); 
					},
					expand: function() {
						ElementUtil.query(sectionPanel, 'content').classList.remove('hide');
					}
				}
			};
			if (sectionPanel.closable) {
				headerDef.closable = true;
			}
			if (sectionPanel.collapsible) {
				headerDef.collapsible = true;
			}
			
			var header = ElementUtil.create(headerDef);
			sectionPanel.append(header);
			
			if (sectionPanel.collapeAtFirst) {
				setTimeout(function(){
					header.collapse();
					ElementUtil.query(sectionPanel, 'content').classList.add('hide');
				}, 100);				
			}
			
		}
		
	}
	
	getAccentColor() {
		return window.DL.Branding.navBackgroundColor;	
	}	
	
};
customElements.define('dl-section-panel', SectionPanel);